import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  highlightError: {
    '& label': {
      color: '#e53935',
    },
    '& fieldset': {
      borderColor: '#e53935',
    },
  },
}))

export default useStyles